module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai659-162b0780af16cc3a55dd3ffc837a6d93.jpg";